// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 806 ? "user" : chunkId) + "." + {"806":"f8f93043","981":"f8f93043"}[chunkId] + ".chunk.css";
};